<button
  mat-flat-button
  type="type"
  [fxFlex.md]="mdFlex"
  [fxFlex.sm]="smFlex"
  [fxFlex.xs]="xsFlex"
  [ngClass.md]="mdClass"
  [ngClass.sm]="smClass"
  [ngClass.xs]="xsClass"
  [disabled]="disabled"
  [ngClass]="{
    defaultClass: defaultClass,
    fullWidth: fullWidth,
    'no-lineheight': noLineHeight,
    fullHeight: fullHeight
  }"
  (click)="onClick($event)">
  {{ label }}
</button>
